// @flow
import React from 'react';

type Props = {
  value: string,
  placeholder: string,
  onChange: (...args: Array<any>) => any
};

const SmsLinkInput = (props: Props) => {
  const { value, onChange, placeholder } = props;

  return (
    <input
      type="text"
      id="search-box"
      className="c-sms-container__input"
      placeholder={placeholder}
      autoComplete="off"
      value={value}
      onChange={onChange}
    />
  );
};

export default SmsLinkInput;
